export enum TransportOrderStatus {
  ToDo,
  InProgress,
  PickedUpVehicle,
  NotPickedUpVehicle,
  DeliveredVehicle,
  Settled,
  Done
}
